import { Spin } from 'antd';
import React, { memo, Suspense, useState } from 'react';
import { useRelayEnvironment } from 'react-relay';

import LoaderUser from '../components/LoaderUser';
import { getObjectFromRelayStoreById } from '../functions';
import { UserType } from '../types';

interface IGantItemControlEditLabel {
    userIdWhoIsEditProject: string;
}

const GantItemControlEditLabelUser: React.FC<IGantItemControlEditLabel> = ({ userIdWhoIsEditProject }) => {
    const environment = useRelayEnvironment();
    const userDataStore = getObjectFromRelayStoreById<UserType>(environment, userIdWhoIsEditProject);
    const [userData, setUserData] = useState<UserType | null | undefined>(userDataStore);

    const filterFlexible = userIdWhoIsEditProject ? `[{"or":[{"id":"${userIdWhoIsEditProject}"}]}]` : undefined;

    console.log('===========>>>', userData);
    const userName = (userData as any)?.name || `${userData?.first_name} ${userData?.last_name}`;

    return (
        <>
            {!userData && (
                <Suspense>
                    <LoaderUser
                        varRequest={{ filter_flexible: filterFlexible }}
                        onUpdateData={(rows) => {
                            if (rows[0]) {
                                console.log('>>>>>>>>>>>>>', rows[0]);
                                setUserData(rows[0]);
                            }
                        }}
                        prefixFetchKey={userIdWhoIsEditProject || undefined}
                    />
                </Suspense>
            )}
            <Spin spinning={!userData}>
                {userData ? `${userName} is editing this project` : '...loading data of user'}
            </Spin>
        </>
    );
};

export default memo(GantItemControlEditLabelUser);
